import Usuario from "model/administracao/cadastro/Usuario";
import CategoriaDocumento from "./CategoriaDocumento";
import { DocumentoPasta } from "./DocumentoPasta";

export default class FiltrosListaMestra {
    internoExterno: string[];
    categoria: CategoriaDocumento | null;
    status: string[];
    responsavel: Usuario | null;
    pasta: DocumentoPasta | null;

    constructor() {
        this.internoExterno = [];
        this.categoria = null;
        this.status = [];
        this.responsavel = null;
        this.pasta = null;
    }
}